import { useState, useEffect } from 'react';

const useDeviceDetect = () => {
  const [isPortrait, setIsPortrait] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);         // ✅ 1st
  const [isMidDesktop, setIsMidDesktop] = useState(false);   // ✅ 2nd
  const [isLargeDesktop, setIsLargeDesktop] = useState(false); // ✅ 3rd

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      setIsPortrait(window.innerHeight > width);
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 992);
      setIsDesktop(width >= 992 && width <= 1200);             // 💡 e.g. 1024, 1152
      setIsMidDesktop(width > 1200 && width <= 1366);          // 💡 e.g. 1280, 1366
      setIsLargeDesktop(width > 1366);                         // 💡 e.g. 1440, 1920
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // initial trigger
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isPortrait,
    isMobile,
    isTablet,
    isDesktop,
    isMidDesktop,
    isLargeDesktop,
  };
};

export default useDeviceDetect;